import React from "react";

const TemplatesInventory = () => {
  return (
    <div>
      <h3 className="text-lg font-bold">Templates</h3>
      <p>Templates Content goes here.</p>
    </div>
  );
};

export default TemplatesInventory;